export default {
	STUDENT: 'student',
	TEACHER: 'teacher',
}
